import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {CustomDateFormatter} from '../../../../_shared/custom-date-formatter';
import {FormUtils} from '../../../../_shared/form-utils';
import {DateUtils} from '../../../../_shared/date-utils';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import * as fileSaver from 'file-saver';
import {
    FalconicStatisticExportCriteriaDto,
    WasteManagementService
} from '../../../../_services/configuration-services';

@Component({
    selector: 'app-export-falconic-statistic-modal',
    templateUrl: './export-falconic-statistic-modal.component.html',
    providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateFormatter }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportFalconicStatisticModalComponent implements OnInit {
    @Input() serviceId: string;

    maxDate: NgbDateStruct;
    DateUtils = DateUtils;

    exportFalconicStatisticForm: UntypedFormGroup;

    constructor(public exportPottingerStatisticModal: NgbActiveModal,
                private readonly wasteManagementService: WasteManagementService) {
    }

    ngOnInit(): void {
        this.exportFalconicStatisticForm = new UntypedFormGroup({
            datePeriod: new UntypedFormGroup({
                from: new UntypedFormControl(null, [FormUtils.datePatternValidator]),
                to: new UntypedFormControl(null, [FormUtils.datePatternValidator]),
            }, [FormUtils.periodValidator])
        }, {updateOn: 'change'});

        this.maxDate = DateUtils.dateToNgbDateStruct(new Date());
    }

    get datePeriod(): UntypedFormGroup {
        return this.exportFalconicStatisticForm.get('datePeriod') as UntypedFormGroup;
    }

    get from(): UntypedFormControl {
        return this.datePeriod.get('from') as UntypedFormControl;
    }

    get to(): UntypedFormControl {
        return this.datePeriod.get('to') as UntypedFormControl;
    }

    exportPottingerStatistics(): void {
        if (!this.exportFalconicStatisticForm.valid) {
            return;
        }

        this.wasteManagementService.exportStatistics(this.serviceId, this.getFormResult()).pipe().subscribe(
            response => {
                this.exportPottingerStatisticModal.close();
                fileSaver.saveAs(response.data, response.fileName);
            }
        );
    }

    private getFormResult(): FalconicStatisticExportCriteriaDto {

        const from = DateUtils.ngbDateStructToDate(this.from.value);
        from?.setHours(0, 0, 0, 0);
        const to = DateUtils.ngbDateStructToDate(this.to.value);
        to?.setHours(23, 59, 59, 59);

        return new FalconicStatisticExportCriteriaDto({
            from: from,
            to: to
        });
    }

}
